import * as Business from '../business';


export function HasFeature({ businessID, feature, children }) {
  const business   = Business.useBusiness(businessID);
  const hasFeature = businessHasFeature(business, feature);

  if (hasFeature)
    return children || null;
  else
    return null;
}

export function businessHasFeature(business, feature) {
  const features   = business?.features ?? {};
  const hasFeature = features[feature];
  return hasFeature;
}
